import styled from 'styled-components';

export const Body = styled.div`
  max-width: 480px;
  width: 100%;
  margin: 0 auto;
  padding-bottom: 20px;
  background-color: #F9F9F9;
  min-height: 100vh;
`;

export const Header = styled.div`
  position: sticky;
  top: 0;
  background-color: white;
  padding: 20px;
  text-align: center;
  font-size: 18px;
  font-weight: 600;
  color: #333;
  border-bottom: 1px solid #E5E5E5;
  z-index: 10;
`;

export const BackButton = styled.button`
  position: absolute;
  left: 20px;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  font-size: 20px;
  color: #333;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Title = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: #333;
`;

export const StarWrapper = styled.div`
  background-color: white;
  margin: 15px 20px;
  padding: 15px;
  border-radius: 15px;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
  justify-content: space-between;

  .star_icon {
    display: inline-flex;
    margin-right: 2px;
  }
`;

export const AverageStar = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 5px;
  gap: 5px;

  .star_icon {
    display: inline-flex;
    align-items: center;

    svg {
      width: 16px;
      height: 16px;
      display: block;
    }
  }
`;

export const StarContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const StarTitle = styled.div`
  font-weight: bold;
  font-size: 15px;
  color: #333;
  margin-bottom: 4px;
  text-align: center;
`;

export const ScoreContainer = styled.div`
  flex: 0 0 auto;
  width: 240px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const CheckBox = styled.div`
  padding: 0 20px;
  margin: 15px 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  font-size: 14px;

  input[type='checkbox'] {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    width: 18px;
    height: 18px;
    background-color: white;
    border: 2px solid #ddd;
    border-radius: 4px;
    cursor: pointer;
    position: relative;

    &:checked {
      background-color: #1FBC70;
      border-color: #1FBC70;

      &::after {
        content: '✓';
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        color: white;
        font-size: 12px;
      }
    }
  }

  .sorting {
    margin-left: 15px;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 5px 10px;
    background-color: white;
    font-size: 14px;
    cursor: pointer;
  }

  .sorting option {
    background-color: white;
    padding: 10px;
  }
`;

export const Review1 = styled.div`
  background-color: white;
  margin: 10px 20px;
  padding: 15px;
  border-radius: 15px;
  box-shadow: 0px 1px 4px rgba(0, 0, 0, 0.12);
`;

export const ImageGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  margin-top: 10px;
  margin-left: 5px;
  width: calc(100% - 5px);
`;

export const ImageWrapper = styled.div<{ hasOverlay?: boolean }>`
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  border-radius: 10px;
  overflow: hidden;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  ${({ hasOverlay }) =>
    hasOverlay &&
    `
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background-color: rgba(0, 0, 0, 0.5);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  `}
`;

export const ImageOverlay = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 24px;
  font-weight: 600;
  z-index: 1;
`;

export const ImageModal = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.9);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalContent = styled.div`
  position: relative;
  max-width: 90%;
  max-height: 90%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalImage = styled.img`
  max-width: 100%;
  max-height: 90vh;
  object-fit: contain;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  font-size: 30px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }
`;

export const NavButton = styled.button<{ direction: 'prev' | 'next' }>`
  position: absolute;
  top: 50%;
  ${({ direction }) => (direction === 'prev' ? 'left: 20px;' : 'right: 20px;')}
  transform: translateY(-50%);
  background: rgba(255, 255, 255, 0.2);
  border: none;
  color: white;
  font-size: 24px;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.3);
  }

  &:disabled {
    opacity: 0.3;
    cursor: not-allowed;
  }
`;

export const ImageCounter = styled.div`
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 8px 16px;
  border-radius: 20px;
  font-size: 14px;
`;

export const ReviewDate = styled.div`
  font-size: 11px;
  color: #B1B1B1;
`;

export const ReviewInfo = styled.div`
  margin-left: 8px;
  flex: 1;
  text-align: left;

  .nickName {
    font-size: 14px;
    font-weight: 500;
    color: #333;
    text-align: left;
  }
`;

export const StarRateWrap2 = styled.div`
  display: flex;
  align-items: center;
  margin-left: auto;

  .star_icon {
    display: inline-flex;
    margin-right: 1px;
  }
`;

export const ImageContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;

  .img1 {
    width: 36px;
    height: 36px;
    border-radius: 18px;
    object-fit: cover;
    margin-top: -2px;
  }
`;

export const ReviewContainer = styled.div`
  padding-bottom: 20px;
`;

export const ReviewDetail = styled.div`
  font-size: 14px;
  color: #5f5e5eff;
  margin-top: 10px;
  margin-bottom: 10px;
  margin-left: 5px;
  text-align: left;
  line-height: 1.5;
`;
